import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import Switch from "react-switch";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";

import {
  getProductUnitByProductIdRequest,
  getProductUnitTypeRequest,
  addProductUnitRequest,
  updateProductUnitByProductUnitIdRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { toastrMessage } from "helpers/messageHelper";
import {
  makeProductUnitSelectField,
  selectSortedProductUnitType,
} from "store/ProductUnit/selector";
import { createStructuredSelector } from "reselect";
import SimpleReactValidator from "simple-react-validator";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";

class ManageUnitForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      productUnitData: productUnitDataInitialState(),
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.props.getProductUnitTypeRequest();
  }

  resetForm = () => {
    this.setState({
      productUnitData: productUnitDataInitialState(),
      operationType: SUBMIT,
    });
    this.validator.hideMessages();
    this.props.resetForm();
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.productUnitApiResponse &&
      this.props.productUnitApiResponse !== nextprops.productUnitApiResponse
    ) {
      if (nextprops.productUnitApiResponse.isSuccessResponse) {
        this.props.getProductUnitByProductIdRequest(this.props.productDetailId);
        toastrMessage(
          nextprops.productUnitApiResponse.responseMessage,
          SUCCESS
        );
        this.resetForm();
      } else if (!nextprops.productUnitApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.productUnitApiResponse.responseMessage, DANGER);
      }
    }

    if (
      nextprops.productUnitRecord &&
      this.props.productUnitRecord !== nextprops.productUnitRecord
    ) {
      if (nextprops.productUnitRecord.productUnitId) {
        this.setState({
          productUnitData: nextprops.productUnitRecord,
          operationType: UPDATE,
        });
      } else {
        this.resetForm();
      }
    }
  }

  formSubmit = (values) => {
    if (values.isMultiUnit) this.validator.fields.unitType = true;
    if (this.validator.allValid()) {
      this.setState({ productUnitData: values });
      if (this.state.operationType === UPDATE) {
        this.props.updateProductUnitByProductUnitIdRequest(
          values.productUnitId,
          values
        );
      } else {
        values.productDetailId = this.props.productDetailId;
        this.props.addProductUnitRequest(values);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <Formik
          initialValues={this.state.productUnitData}
          enableReinitialize={true}
          onSubmit={this.formSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <Row className="form-group px-2">
                <Col
                  md="6"
                  lg="3"
                  xl="2"
                  className={
                    "px-1 my-1 " + (values.isMultiUnit ? "col-12" : "col-7")
                  }
                >
                  <Field
                    name="unitValue"
                    type="text"
                    className="form-control"
                    placeholder="Unit Value"
                  ></Field>
                  {this.validator.message(
                    "unitValue",
                    values.unitValue,
                    "required"
                  )}
                </Col>

                {!values.isMultiUnit && (
                  <Col xs="5" md="6" lg="3" xl="2" className="px-1 my-1">
                    <Field
                      component={Select}
                      name="unitType"
                      placeholder="Unit Type"
                      options={this.props.sortedProductUnitType}
                      onChange={(opt, e) => {
                        setFieldValue("unitType", opt.value);
                      }}
                      value={this.props.sortedProductUnitType.filter(
                        (option) => option.value === values.unitType
                      )}
                    ></Field>
                    {this.validator.message(
                      "unitType",
                      values.unitType,
                      "required"
                    )}
                  </Col>
                )}
                <Col md="6" lg="2" className="px-1 my-1">
                  <Field
                    name="unitMRP"
                    type="number"
                    className="form-control"
                    placeholder="MRP"
                    min="1"
                    step=".01"
                  ></Field>
                  {this.validator.message(
                    "unitMRP",
                    values.unitMRP,
                    "required|numeric|min:1,num"
                  )}
                </Col>
                <Col md="6" lg="2" className="px-1 my-1">
                  <Field
                    name="unitSP"
                    type="number"
                    className="form-control"
                    placeholder="Selling Price"
                    min="1"
                    step=".01"
                  ></Field>
                  {this.validator.message(
                    "unitSP",
                    values.unitSP,
                    "required|numeric|min:1,num"
                  )}
                </Col>
                <Col md="6" lg="2" className="px-1 my-1">
                  <Field
                    name="unitQty"
                    type="number"
                    className="form-control"
                    placeholder="Qunatity"
                    min="1"
                  ></Field>
                  {this.validator.message(
                    "unitQty",
                    values.unitQty,
                    "required|numeric|min:1,num"
                  )}
                </Col>
                <Col
                  md="6"
                  lg="3"
                  xl="2"
                  className="my-1 d-flex justify-content-between align-items-center"
                >
                  <label>Is Multi Unit:</label>
                  <Switch
                    className="switch-sm"
                    onColor={primaryColor}
                    offColor={secondaryColor}
                    onChange={() =>
                      setFieldValue("isMultiUnit", !values.isMultiUnit)
                    }
                    checked={values.isMultiUnit}
                  />
                </Col>
                <Col md="12" lg="9" xl="12" className="px-1 my-1">
                  <FormGroup className="mb-0 text-right">
                    <div>
                      <Button type="submit" color="primary" className="mr-1">
                        {this.state.operationType}
                      </Button>

                      <Button
                        type="reset"
                        color="secondary"
                        onClick={() => this.resetForm()}
                      >
                        Reset
                      </Button>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productUnitApiResponse: makeProductUnitSelectField("productUnitApiResponse"),
  sortedProductUnitType: selectSortedProductUnitType(),
});

const withConnect = connect(mapStatetoProps, {
  getProductUnitByProductIdRequest,
  getProductUnitTypeRequest,
  updateProductUnitByProductUnitIdRequest,
  addProductUnitRequest,
});

export default compose(withConnect, withRouter)(ManageUnitForm);
//export default withRouter(withConnect)(Index);

function productUnitDataInitialState() {
  return {
    unitType: null,
    unitValue: "",
    unitMRP: "",
    unitSP: "",
    unitQty: "",
    isMultiUnit: false,
  };
}
